// Common
import { ReactElement } from 'react'

// Components
import Row from 'shared-components/row'

// Hooks
import useMobile from '../../../hooks/useMobile'
import Col from 'shared-components/col'

interface IProps {
	children: ReactElement[] | ReactElement | null
}

function QuizBody(props: IProps): ReactElement {
	const mobile = useMobile()
	return (
		<>
			{mobile ?
				<Col>
					{props.children}
				</Col>
				:
				<Row>
					{props.children}
				</Row>
			}
		</>
	)
}

export default QuizBody
